/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpecificationGroup } from './SpecificationGroup';
import {
    SpecificationGroupFromJSON,
    SpecificationGroupFromJSONTyped,
    SpecificationGroupToJSON,
} from './SpecificationGroup';

/**
 * 
 * @export
 * @interface Specification
 */
export interface Specification {
    /**
     * 
     * @type {string}
     * @memberof Specification
     */
    name?: string;
    /**
     * 
     * @type {SpecificationGroup}
     * @memberof Specification
     */
    group?: SpecificationGroup;
    /**
     * 
     * @type {string}
     * @memberof Specification
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof Specification
     */
    unit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Specification
     */
    useAsFacet?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Specification
     */
    sortOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof Specification
     */
    type?: string;
}

/**
 * Check if a given object implements the Specification interface.
 */
export function instanceOfSpecification(value: object): boolean {
    return true;
}

export function SpecificationFromJSON(json: any): Specification {
    return SpecificationFromJSONTyped(json, false);
}

export function SpecificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Specification {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'group': json['group'] == null ? undefined : SpecificationGroupFromJSON(json['group']),
        'value': json['value'] == null ? undefined : json['value'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'useAsFacet': json['useAsFacet'] == null ? undefined : json['useAsFacet'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function SpecificationToJSON(value?: Specification | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'group': SpecificationGroupToJSON(value['group']),
        'value': value['value'],
        'unit': value['unit'],
        'useAsFacet': value['useAsFacet'],
        'sortOrder': value['sortOrder'],
        'type': value['type'],
    };
}

